module.exports = __webpack_public_path__ + "img/wl.6ab4c52a.png";